<template>
  <div class="c8-explanation__content">
    <p>根据每个位置开奖号码的大小单双结果，以走势图的形式展示，共有大单（7、9）、大双（6、8、10）、小单（1、3、5）、小双（2、4）4种属性的走势分布，可使用该图表进一步缩小选号范围、精确定位号码或辅助进行复合式的两面投注</p>
  </div>
</template>

<script>
export default {
  name: 'PK10WebLiangMianHengBanZouShih' // pk10 兩面橫版走勢
}
</script>
